export default () => {
	const getColor = (val,hex_color = false) => {
		let cls = "text-dark";
		let hex = "#000000";
		switch (val) {
			case 'ML':
			case 'Draft':{
				cls = 'text-light'
				hex = '#adb5bd'
				break;
			}
			case 'STL':
			case 'Pending':{
				cls = 'text-warning'
				hex = '#DC9A0F'
				break;
			}
			case 'SIL':
			case 'PASS':
			case 'Submitted':
			case 'Approve':
			case 'Approved':
			case 'Complete':
			case 'Completed':{
				cls = 'text-success'
				hex = '#0BC196'
				break;
			}
			case 'FL':
			case 'FAIL':
			case 'Reject':
			case 'Rejected':
			case 'Cancel':
			case 'Canceled':{
				cls = 'text-danger'
				hex = '#DF3030'
				break;
			}
			case 'SL':{
				cls = 'text-info'
				hex = '#1cc4f4'
				break;
			}
			case 'FEL':{
				cls = 'text-primary'
				hex = '#6caca4'
				break;
			}
		}
		return (hex_color) ? hex : cls
	}
	const getBgColor = (val,hex_color = false) => {
		let cls = "bg-light";
		let hex = "#000000";
		switch (val) {
			case 'ML':{
				cls = 'bg-light'
				hex = '#adb5bd'
				break;
			}
			case 'STL':{
				cls = 'bg-warning'
				hex = '#DC9A0F'
				break;
			}
			case 'SIL':{
				cls = 'bg-success'
				hex = '#0BC196'
				break;
			}
			case 'FL':{
				cls = 'bg-danger'
				hex = '#DF3030'
				break;
			}
			case 'SL':{
				cls = 'bg-info'
				hex = '#1cc4f4'
				break;
			}
			case 'FEL':{
				cls = 'bg-primary'
				hex = '#6caca4'
				break;
			}
		}
		return (hex_color) ? hex : cls
	}
	const getRiskColor = (risk) => {
		switch (risk) {
			case 1:
				return '#67B258'
				break;
			case 2:
				return '#F3BC43'
				break;
			case 3:
				return '#BB342C'
				break;
			case 4:
				return '#E46D37'
				break;
			default:
				return '#DEE5EF'
				break;
		}
	}
	const colorClassList = [
		{
			color_class: 'text-dark',
			label: 'Black'
		},
		{
			color_class: 'text-info',
			label: 'Blue'
		},
		{
			color_class: 'text-danger',
			label: 'Red'
		},
		{
			color_class: 'text-warning',
			label: 'Yellow'
		},
		{
			color_class: 'text-success',
			label: 'Green'
		}
	]
	const paymentTypes = [
		'Credit card - Merchant',
		'IBG Transfer',
		'Instant Transfer',
		'Cheques',
		'Cash Payment',
		'Payment Gataway',
		'Autorize Payment (ICSB)',
		'Standing Order',
		'Invoice',
		'Payroll Deduction',
		'Not Applicable',
		'Standard Instruction'
	]

	const paymentCategory = {
		// DISBURSEMENT: 'Disbursement',
		REPAYMENT: 'Repayment',
		REDEMPTION: 'Redemption',
		ADVANCE_PAYMENT: 'Advance Payment',
		LATE_CHARGES: 'Late Charge',
		LATE_WAIVED: 'Late Charge - Waived',
		INTEREST: 'Interest',
		MANUAL_REBATE: 'Manual Rebate',
		MANUAL_FEE_CHARGE: 'Manual Fee Charge',
		MANUAL_ADJUSTMENT: 'Manual Adjustment',
		OTHER: 'Other',
	}

	const smsType = {
		INV_MONTHLY_INSTALLMENT :'Monthly Instalment',
		INV_OVERDUE_PAYMENT :'Overdue Payment',
		INV_MORATORIUM_EXPIRES :'Moratorium Expires',
		INV_LO_LOAN_APPLICATION :'Letter of Offer',
		INV_LOAN_REJECTED :'Loan Rejection',
		INV_LOAN_APPROVED :'Loan Approved',
		INV_LOAN_PROCESSING :'Loan Processing',
	}

	const emailTriggerPoints = {
		INITIAL_PROPOSAL_SUBMIT_TRIGGER: 'Initial Proposal Submit Trigger',
		INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change',
		INITAL_PROPOSAL_APPROVAL_CHANGE: 'Initial Proposal Approval Change',
		CASE_APPROVE: 'Case Approve',
		CASE_REJECT: 'Case Reject',
		CASE_CREATED: 'Case Created',
		LOAN_ADVISORY: 'Send To Advisory',
		ASSIGN_ADVISOR: 'Assign Advisor',
		CASE_PENDING_APPROVAL: 'Case Pending Approval',
		CREATE_CASE_APPROVAL: 'Create Case Approval'
	};
	
	const notificationTriggerPoints = {
		LEAD_STATUS_CHANGE: 'Lead Status Change',
		CASE_STATUS_CHANGE: 'Case Status Change',
		CUSTOMER_STATUS_CHANGE: 'Customer Status Change',
		CHAT_MESSAGE: 'Chat Message',
		INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change'
	};
	
	return {
		getColor,
		getBgColor,
		getRiskColor,
		colorClassList,
		paymentTypes,
		paymentCategory,
		smsType,
		emailTriggerPoints,
		notificationTriggerPoints
	}
}
  